import {IHttpPromise, IHttpService} from "angular";
import {getAbsoluteUrl} from "../../utils/urlUtill";
import {LqbFundedReportLog} from "../model/LqbFundedReportLog";
import {Page} from "../../utils/models/Page";
import {ImportReportLogFilter} from "../../opportunities_filter/model/OpportunityFilterUi";

export class LqbFundedLogService {

    public static instance = ['$http', LqbFundedLogService];
    private $http: IHttpService;

    constructor($http: IHttpService) {
        this.$http = $http;
    }

    public getLqbFundedLogs = (page: number,
                               size: number,
                               filter: ImportReportLogFilter): IHttpPromise<Page<LqbFundedReportLog>> => {
        // let endDate = filter.endDate;
        // filter.endDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate() + 1)
        return this.$http({
            method: 'POST',
            url: getAbsoluteUrl('api/import/report/log'),
            params: {page: page, size: size},
            data: filter
        });

    }

}